import { render, staticRenderFns } from "./OrderHandOver.vue?vue&type=template&id=0100d0a8"
import script from "./OrderHandOver.vue?vue&type=script&lang=js"
export * from "./OrderHandOver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports